import {BoxSvg} from '../../Components/Icons/BoxSvg';
import {DBSvg} from '../../Components/Icons/DBSvg';
import {PenSvg} from '../../Components/Icons/PenSvg';

export type CardData = {
	img: any;
	title: string;
	description: string;
	fullDescription?: any;
};

export const cardsData: CardData[] = [
	{
		img: (
			<div className={'icon-svg'}>
				<PenSvg />
			</div>
		),
		fullDescription: (
			<>
				Outsource your SWIFT connectivity and SWIFT messaging interface infrastructure SAA/SAE,
				<span className="hide-three-dots">...</span> while keeping full control. Our hosting includes
				monitoring, support, maintenance, system health checks, services and upgrades of new SWIFT
				releases.,
			</>
		),
		title: 'Dedicated Alliance Access/Entry',
		description:
			'Outsource your SWIFT connectivity and SWIFT messaging interface infrastructure SAA/SAE, while keeping full control'
	},
	{
		img: (
			<div className={'icon-svg'}>
				<BoxSvg />
			</div>
		),
		fullDescription: (
			<>
				This type of connection to the system is implemented by means of program and
				<span className="hide-three-dots">...</span> technical support of Service Bureau. It allows
				the bank to significantly reduce its costs, related to acquisition of cryptographic devices,
				licenses for SWIFT services, the support of its own channel, acquisition of its own server
				systems and training of its own specialists.,
			</>
		),

		title: 'Shared Alliance Access',
		description:
			'This type of connection to the system is implemented by means of program and technical support...'
	},
	{
		img: (
			<div className={'icon-svg'}>
				<DBSvg />
			</div>
		),
		fullDescription: (
			<>
				In case of this type of connection to the system, the application Alliance Access/Entry
				remains<span className="hide-three-dots">...</span> in the bank and the applications of
				SWIFTNet (Alliance Gateway, SNL, HSMs, Alliance Connect, VPN boxes and channel with SWIFT
				Network Partners) are handed over to Service Bureau.,
			</>
		),

		title: 'Shared Alliance Gateway',
		description:
			'This type of connection to the system is implemented by means of program and technical support of Service Bureau. It allows the bank to significantly reduce its costs, related to acquisition of cryptographic devices, licenses for SWIFT services, the support of its own channel, acquisition of its own server systems and training of its own specialists.'
	},
	{
		img: (
			<div className={'icon-svg'}>
				<BoxSvg />
			</div>
		),
		fullDescription: (
			<>
				The Reserve connection is implemented according to “Gateway” connection scheme
				<span className="hide-three-dots">...</span> and ensures the bank a reliable connection to the
				network, in case of a problem with the main connection.,
			</>
		),

		title: 'Reserve Connection',
		description:
			'The Reserve connection is implemented according to “Gateway” connection scheme and ensures the bank...'
	}
];

export type Logo = string;

// export const logos: Logo[] = [logo1, logo2, logo3, logo4, logo5];

export type Advantage = {
	id: number;
	text: string;
};

export const advantages: Advantage[] = [
	{id: 1, text: 'Continuous updates to ensure compliance and future proofing of new technology'},
	{id: 2, text: 'Modular concept based on cutting-edge technology and standards'},
	{id: 3, text: 'Easy integration with existing in-house systems'},
	{id: 4, text: 'System operated and monitored by the local SWIFT Experts'},
	{id: 5, text: 'Scalable system to grow with your needs'}
];

export type FAQ = {
	question: string;
	answer: string;
	hasLink?: boolean;
};

export const faqData: FAQ[] = [
	{
		question: 'Why Do Banks and Financial Institutions Prefer to Outsource Their Swift Connection?',
		answer: `Outsourcing SWIFT connectivity and infrastructure has become increasingly popular in recent years as a way of reducing maintenance and system support costs and improving level of performance in the SWIFT environment. SWIFT Service Bureau provides the ability to focus on core business competencies. By outsourcing to SWIFT Service Bureau, banks and financial institutions can be confident that will get fast and secure access to the full suite of SWIFT services, as well as will have the opportunity to reduce operational costs and risks.`
	},
	{
		question: 'Are You Swift-certified?',
		answer: `Yes, we are certified by SWIFT. Today ITG is the only fully accredited partner of SWIFT in Armenia that provides banks and financial institutions with access to the complete range of SWIFT services. Using the status of the SWIFT Service Bureau, our company delivers the opportunity to communicate with more than 11 thousand banks and other financial institutions in more than 200 countries and territories and send/receive information about financial transactions in a secure, standardized and reliable environment.`,
		hasLink: true
	},
	{
		question: 'How Reliable is Your Service Bureau?',
		answer: `Our service bureau is designed with reliability and security in mind, ensuring seamless operations.`
	},
	{
		question: 'What Key Benefits Does Your Service Bureau Offer?',
		answer: `We provide reduced operational costs, streamlined connectivity, and 24/7 support.`
	},
	{
		question: 'How Can We Control and Monitor Our Company’s Swift Environment?',
		answer: `Our platform offers intuitive dashboards and monitoring tools to ensure compliance and transparency.`
	}
];
